// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1sK0I","icon":"SortAdornment_icon__2qiii","up":"SortAdornment_up__2xART","down":"SortAdornment_down__2Bz2_","active":"SortAdornment_active__1ctsV"};